export default __webpack_public_path__ + "static/community-b5d06f20ade8330210ca7bfe4dc0b26d.svg";